export const sidebarToggle = () => ({
  type: "TOGGLE_SIDEBAR",
});

export const sidebarClose = () => ({
  type: "CLOSE_SIDEBAR",
});

export const sidebarSetKeyValue = (key, value) => ({
  type: "SET_SIDEBAR_KEY",
  payload: { key, value },
});

export const sidebarClear = () => ({
  type: "CLEAR_SIDEBAR",
});

export const sidebarReset = () => ({
  type: "RESET_SIDEBAR",
});

// ---- NEW actions ----
export const sidebarTypeSet = (type) => ({
  type: "SET_SIDEBAR_TYPE",
  payload: type,
});

export const sidebarChecklistSet = (checklist) => ({
  type: "SET_SIDEBAR_CHECKLIST",
  payload: checklist,
});

export const sidebarChecklistClear = () => ({
  type: "CLEAR_SIDEBAR_CHECKLIST",
});

export const sidebarTypeToggle = (type) => ({
  type: "TOGGLE_SIDEBAR_TYPE",
  payload: type,
});

export const sidebarTypeClear = () => ({
  type: "CLEAR_SIDEBAR_TYPE",
});

export const sidebarSetStateValue = (someState) => ({
  type: "SET_SIDEBAR_STATE",
  payload: someState,
});

export const sidebarSetParamsValue = (state) => ({
  type: "SET_SIDEBAR_PARAMS",
  payload: state,
});

export const sidebarClearStateValue = () => ({
  type: "CLEAR_SIDEBAR_STATE",
});

/**
 * Usage
  dispatch(
  sidebarSetValues({
    name: "someName",
    state: "someState",
    open: true,
  })
);
 */
export const sidebarSetValues = (valuesObject) => {
  return {
    type: "SET_SIDEBAR_VALUES",
    payload: valuesObject,
  };
};
